import React, { useState } from 'react';
import { type IChildAccount } from '../../interfaces/IChildAccount';
import AccountsTable from './AccountsTable';

interface AccountsSectionProps {
  accounts: IChildAccount[];
  title: string;
  canUpdate: boolean;
  eventSlug?: string;
  organizationAccount?: string;
}

const AccountsSection: React.FC<AccountsSectionProps> = ({
  accounts,
  title,
  canUpdate,
  eventSlug,
  organizationAccount,
}) => {
  const [visibleAccounts, setVisibleAccounts] = useState(100);

  const handleShowMore = () => {
    setVisibleAccounts((prevVisible) => prevVisible + 100);
  };

  if (accounts.length === 0) {
    return null;
  }

  return (
    <li className="space-y-2 rounded-md py-4 list-none">
      <div className="flex items-center justify-between mb-2">
        <h2 className="flex-grow px-2 text-md font-medium text-dataops-yale-blue">{title}</h2>
        <div className="flex justify-center items-center h-6 px-3 mr-2 rounded-full bg-dataops-platinum-gray text-xs">
          {accounts.length}
        </div>
      </div>
      <AccountsTable
        accounts={accounts.slice(0, visibleAccounts)}
        canUpdate={canUpdate}
        eventSlug={eventSlug}
        organizationAccount={organizationAccount}
      />
      {visibleAccounts < accounts.length && (
        <button onClick={handleShowMore} className="w-full text-sm/6 text-sky-600 hover:underline mt-2">
          Show more accounts
        </button>
      )}
    </li>
  );
};

export default AccountsSection;
